import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Produto } from '@mobile/models/cardapio/cardapio.model';

@Injectable({ providedIn: 'root' })
export class ProdutosFirebaseService {
  constructor(private afs: AngularFirestore) {}

  async getAll(): Promise<Produto[]> {
    const snapshot = await this.afs.firestore.collection('Produtos').get();
    return snapshot.docs.map(d => d.data() as Produto);
  }
}
